var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "float-right pr-4"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.show = !_vm.show;
      }
    }
  }, [_vm.show ? _c('v-icon', [_vm._v("mdi-chevron-up")]) : _c('v-icon', [_vm._v("mdi-chevron-down")])], 1)], 1), _c('div', {
    staticClass: "px-4 my-4",
    on: {
      "click": function click($event) {
        _vm.show = true;
      }
    }
  }, [_c('p', {
    staticClass: "title primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Voice')))]), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('CV'),
      "v": _vm.named.m_CVText,
      "width": "33%"
    }
  })], 1), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }]
  }, [_vm.loading ? _c('div', {
    staticClass: "py-4 text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }), _vm.dl_error ? _c('div', [_vm._v(_vm._s(_vm.$t("failed download audio data")))]) : _vm._e()], 1) : [_c('v-tabs', {
    attrs: {
      "background-color": "transparent",
      "grow": ""
    },
    model: {
      value: _vm.type,
      callback: function callback($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  }, _vm._l(_vm.types, function (t) {
    return _c('v-tab', {
      key: "character-voice-tab-".concat(t)
    }, [_vm._v(_vm._s(_vm.$t("Character Voice Type.".concat(t))))]);
  }), 1), _c('v-tabs-items', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.type,
      callback: function callback($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  }, _vm._l(_vm.types, function (t) {
    return _c('v-tab-item', {
      key: "character-voice-tab-item-".concat(t),
      staticClass: "py-4",
      attrs: {
        "touchless": ""
      }
    }, [t === 0 || t === 3 ? _vm._l(_vm.cues[t], function (n, cueID) {
      return _c('div', {
        key: "character-voice-cue-".concat(cueID)
      }, [_c('p', {
        staticClass: "px-4 subtitle-1"
      }, [_vm._v(_vm._s(_vm.$t("Character Voice Category.".concat(cueID))))]), _c('Scroller', {
        attrs: {
          "icon": "56"
        }
      }, [_vm._l(n, function (i) {
        return _c('div', {
          key: "character-voice-cue-".concat(cueID, "-").concat(i),
          staticClass: "ml-4 d-flex"
        }, [_c('Voice', {
          staticClass: "mr-2",
          attrs: {
            "name": _vm.named.m_ResouceBaseName,
            "cue": "voice_".concat(cueID, "_").concat(i - 1),
            "override_url": _vm.cue_url["voice_".concat(cueID, "_").concat(i - 1, ".wav")]
          }
        }), _c('div', {
          staticClass: "d-flex justify-center flex-column"
        }, [i == 1 && _vm.tweets["voice_".concat(cueID)] ? _c('div', {
          staticClass: "line",
          domProps: {
            "innerHTML": _vm._s(_vm.tweets["voice_".concat(cueID)].replace(/\n/g, '<br>'))
          }
        }) : _c('div', {
          staticClass: "line"
        }, [_vm._v(_vm._s("voice_".concat(cueID, "_").concat(i - 1)))])])], 1);
      }), _c('div', {
        staticClass: "pl-4"
      })], 2)], 1);
    }) : t === 4 ? [_vm.dl_error ? _c('div', {
      staticClass: "py-4 text-center"
    }, [_c('div', [_vm._v(_vm._s(_vm.$t("failed download audio data")))])]) : _vm._e(), !_vm.isCardVoiceLoaded ? _c('div', {
      staticClass: "py-4 text-center"
    }, [_c('v-progress-circular', {
      attrs: {
        "indeterminate": "",
        "color": "primary"
      }
    }), _vm.dl_error ? _c('div', [_vm._v(_vm._s(_vm.$t("failed download audio data")))]) : _vm._e()], 1) : _vm._l(_vm.cues[t], function (chara, index) {
      return _c('div', {
        key: "character-voice-cue-".concat(chara.charaname + index)
      }, [_c('p', {
        staticClass: "px-4 subtitle-1"
      }, [_vm._v(_vm._s(_vm.getCharaName(chara.charaname)))]), _c('Scroller', {
        attrs: {
          "icon": "56"
        }
      }, [_vm._l(chara.data, function (data) {
        return _c('div', {
          key: "character-voice-cue-".concat(data.fileName),
          staticClass: "ml-4 d-flex"
        }, [_c('Voice', {
          staticClass: "mr-2",
          attrs: {
            "name": chara.charaname,
            "cue": data.fileName.replace('.wav', ''),
            "override_url": data.url
          }
        }), _c('div', {
          staticClass: "d-flex justify-center flex-column"
        }, [_c('div', {
          staticClass: "line"
        }, [_vm._v(_vm._s(data.fileName.replace(".wav", "")))])])], 1);
      }), _c('div', {
        staticClass: "pl-4"
      })], 2)], 1);
    })] : t === 1 || t === 2 ? _vm._l(_vm.cues[t], function (item, cat) {
      return _c('div', {
        key: "character-voice-cue-".concat(cat)
      }, [_c('p', {
        staticClass: "px-4 subtitle-1"
      }, [_vm._v(_vm._s(_vm.$t("Character Voice Category.".concat(cat))))]), _c('Scroller', {
        attrs: {
          "icon": "56"
        }
      }, [_vm._l(item, function (n, cueID) {
        return _vm._l(n, function (i) {
          return _c('div', {
            key: "character-voice-cue-".concat(cueID, "-").concat(i),
            staticClass: "ml-4 d-flex"
          }, [_c('Voice', {
            staticClass: "mr-2",
            attrs: {
              "name": _vm.named.m_ResouceBaseName,
              "cue": "voice_".concat(cueID, "_").concat(i - 1),
              "override_url": _vm.cue_url["voice_".concat(cueID, "_").concat(i - 1, ".wav")]
            }
          }), _c('div', {
            staticClass: "d-flex justify-center flex-column"
          }, [i === 1 && _vm.tweets["voice_".concat(cueID)] ? _c('div', [_c('div', {
            staticClass: "line",
            domProps: {
              "innerHTML": _vm._s(_vm.tweets["voice_".concat(cueID)].replace(/\n/g, "<br>"))
            }
          })]) : _c('div', [_c('div', {
            staticClass: "line"
          }, [_vm._v(_vm._s("voice_".concat(cueID, "_").concat(i - 1)))])])])], 1);
        });
      }), _c('div', {
        staticClass: "pl-4"
      })], 2)], 1);
    }) : _vm._e()], 2);
  }), 1)]], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }